import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import ProjectDetail from './pages/ProjectDetail';
import ProjectHistory from './pages/ProjectHistory';
import AuthGate from './components/AuthGate';

function App() {
  return (
    <AuthGate>
      <div style={{ minHeight: '100vh', background: '#f8f9fa' }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/project/:projectName" element={<ProjectDetail />} />
          <Route path="/project/:projectName/history" element={<ProjectHistory />} />
        </Routes>
      </div>
    </AuthGate>
  );
}

export default App;